module.exports = __webpack_public_path__ + "img/bg.3fff8174.png";